import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type InternalCommunicationAgentProps = {
  parsedContent: any;
  handleSuggestionClick: (suggestion: string) => void;
};

export default function InternalCommunicationAgent({
  parsedContent,
  handleSuggestionClick,
}: InternalCommunicationAgentProps): JSX.Element {
  const finalAnswer = safeJSONParse(parsedContent?.finalAnswer);
  const question = parsedContent?.question;
  return (
    <div className={styles.pressReleaseContent}>
      <h4>Email Subject: {finalAnswer?.payload?.email?.subject}</h4>
      <div style={{ marginBottom: "20px" }}>
        {finalAnswer?.payload?.email?.greeting}
      </div>
      <div>
        {finalAnswer?.payload?.email?.body_paragraphs?.map(
          (body: string, idx: number) => (
            <p key={idx}>{body}</p>
          )
        )}
      </div>
      <div className={styles.p20}>{finalAnswer?.payload?.email?.closing}</div>
      <div style={{ marginBottom: "20px" }}>
        {finalAnswer?.payload?.email?.signature_block}
      </div>
      {finalAnswer?.payload?.suggestions &&
        finalAnswer?.payload?.suggestions?.length > 0 && (
          <div className={styles.suggestionsContainer}>
            {finalAnswer?.payload?.suggestions?.map(
              (suggestion: string, idx: number) => (
                <div
                  className={styles.suggestionBox}
                  key={idx}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  <p>{suggestion}</p>
                </div>
              )
            )}
          </div>
        )}
      <div className={styles.finalQuestion}>{question}</div>
    </div>
  );
}
